/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Icon, Stack, StyledModal, Text } from 'sarsaparilla';

export default function HowTheLotteryWorksModal({
    isDateRange = false,
    isOpen,
    closeModal,
}: {
    isDateRange?: boolean;
    isOpen: boolean;
    closeModal: () => void;
}) {
    return (
        <StyledModal
            size="md"
            isOpen={isOpen}
            heading={
                <>
                    <span className="per-modal-icon">
                        <Icon iconName="info" />
                    </span>
                    How do the lottery choices work?
                </>
            }
            onRequestClose={closeModal}
        >
            <Stack>
                <Text>
                    You can enter several choices. The order of your choices matter. When
                    evaluating your application, the system will start with your first
                    choice. If it finds availability with that choice, it will award a
                    permit reservation. If it doesn&apos;t find availability, the system
                    moves to the next choice. If no availability is found with any choice,
                    it will consider the application unsuccessful.
                </Text>
                {isDateRange && (
                    <>
                        <div>
                            <Text size="lg" fontWeight="semibold">
                                Single Date
                            </Text>
                            <Text>
                                Selecting this option allows you to enter a single date
                                for your application. When evaluating your application for
                                the lottery, the system will look at the selected date for
                                availability. If there is enough availability it will
                                award a permit. If there is not enough availability it
                                will move to the next choice.
                            </Text>
                        </div>
                        <div>
                            <Text size="lg" fontWeight="semibold">
                                First Date Available Within
                            </Text>
                            <Text>
                                Allows you to choose a range of dates that you would be
                                willing to use for this permit. When your application is
                                evaluated, the system will start at the beginning of the
                                range to look for an available date. If a date is not
                                available, the system will look at the next date. This
                                will repeat until it finds a date with availability or it
                                reaches the end of the range.
                            </Text>
                        </div>
                    </>
                )}
            </Stack>
        </StyledModal>
    );
}
